import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useFormik } from "formik";
import { Form } from "react-bootstrap";
import Button from "../Common/Button";
import "react-datepicker/dist/react-datepicker.css";
import { toast } from "react-toastify";
import ConfirmSpousePopup from "./ConfirmSpousePopup";
import ModalCustom from "../Common/ModalCustom";
import GrantorLicenseUploadField from "./GrantorLicenseUploadField";
import useGrantorLicenseUpload from "../../hooks/useGrantorLicenseUpload";
import { grantorLicenseValidation } from "../../utils/grantorLicenseUpload";

const validate = (values) => {
  const errors = {};
  if (!values.ssnNumber) {
    errors.ssnNumber = "*SSN/ITIN Number is required to Sign Up";
  }
  if (!values.ssnConfirmNumber) {
    errors.ssnConfirmNumber = "*Confirm SSN/ITIN Number is required to Sign Up";
  } else if (values.ssnNumber !== values.ssnConfirmNumber) {
    errors.ssnConfirmNumber = "*SSN/ITIN and confirm SSN/ITIN do not match";
  }
  if (!values.ssnNumber) {
    errors.ssnNumber = "*SSN/ITIN Number is required to Sign Up";
  } else if (values.ssnNumber?.length < 9) {
    errors.ssnNumber = "SSN/ITIN number must be 9 digits long";
  }
  return { ...errors, ...grantorLicenseValidation(values) };
};
const SpouseSignUp2 = ({ handleBack, data1, handleSubmit, savedFormData, onSaveFormData }) => { // NOSONAR
  document.title = "National Trust Registry | Sign Up";
  const { id } = useParams();
  const [value, setValue] = useState("");
  const [ssnValue, setSsnValue] = useState("");
  const [valueCnf, setValueCnf] = useState("");
  const [ssnValueCnf, setSsnValueCnf] = useState("");
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    if (savedFormData?.ssnNumber) {
      setValue(savedFormData.ssnNumber);
      setSsnValue(savedFormData.ssnNumber);
    }
    if (savedFormData?.ssnConfirmNumber) {
      setValueCnf(savedFormData.ssnConfirmNumber);
      setSsnValueCnf(savedFormData.ssnConfirmNumber);
    }
  }, [savedFormData]);

  let initialValuesWithoutEmail = {
    timezone: "Asia/Kolkata",
    role: 2,
    ssnConfirmNumberValue: "",
    ssnConfirmNumber: "",
    ssnNumber: "",
    ssnValue: "",
    drivingLicenseFront: "",
    drivingLicenseBack: "",
    drivingLicenseFrontShow: "",
    drivingLicenseBackShow: "",
  };
  if (id) {
    initialValuesWithoutEmail.email = id;
  }
  const formik = useFormik({
    initialValues: savedFormData || initialValuesWithoutEmail,
    enableReinitialize: true,
    validate,
    onSubmit: async (values) => {
      const data = {
        ...values,
        ...data1,
      };
      console.log(data);
      localStorage.setItem('spouse-data', JSON.stringify(data));
      setShowPopup(true)
      //   Cookies.set("ntr-email-register", data.email, { expires: 36400 });
      //     navigate("/sign-up-verify", { state: response?.payload?.data?._id });
      //     toast.success(response?.payload?.message, { autoClose: 3000 });
      //     // navigate("/grantor-verify");
      //   } else {
      //     toast.error(response?.payload?.message, {
      //       autoClose: 3000,
      //     });
      //   }
      // } else {
      //   toast.error(response?.payload?.response?.data?.message, {
      //     autoClose: 3000,
      //   });
      // }
      localStorage.setItem("userTitle", formik.values.firstName);
    },
  });

  const {
    fileFrontRef,
    fileBackRef,
    frontPreview,
    backPreview,
    isUploadingFront,
    isUploadingBack,
    isUploading,
    handleSvgFrontClick,
    handleSvgBackClick,
    drivingLicenseFront,
    drivingLicenseBack,
    removeDrivingLicenseFront,
    removeDrivingLicenseBack,
  } = useGrantorLicenseUpload(formik);

  const handleGoBack = () => {
    onSaveFormData?.(formik.values);
    handleBack();
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    if (isUploading) {
      toast.error("Please wait for file uploads to complete.", {
        autoClose: 3000,
      });
      return;
    }
    formik.handleSubmit(e);
  };

  const replaceAt = (str, index, character) => {
    return (
      str.substr(0, index) + character + str.substr(index + character.length)
    );
  };

  const transformDisplay = (val) => {
    let displayVal = val.replace(/[^0-9]/g, "").substr(0, 9);

    if (displayVal.length >= 4) {
      displayVal = displayVal.slice(0, 3) + "-" + displayVal.slice(3);
    }

    if (displayVal.length >= 7) {
      displayVal = displayVal.slice(0, 6) + "-" + displayVal.slice(6);
      const lastFour = displayVal.slice(7);
      displayVal = displayVal.slice(0, 7).replace(/\d/g, "*") + lastFour;
    } else {
      displayVal = displayVal.replace(/\d/g, "*");
    }

    return displayVal;
  };

  const transformValue = (val) => {
    let cleanVal = val.replace(/[^0-9|\\*]/g, "");
    cleanVal = cleanVal.substr(0, 9);
    let updatedValue = value ? value : "";

    for (let i = 0, l = cleanVal.length; i < l; i++) {
      if (/[0-9]/g.exec(cleanVal[i])) {
        updatedValue = replaceAt(updatedValue, i, cleanVal[i]);
      }
    }
    updatedValue = updatedValue.substr(0, cleanVal.length);
    formik.setFieldValue("ssnNumber", updatedValue);
    setValue(updatedValue);
  };

  const syncInput = (event) => {
    const val = event.target.value;
    formik.setFieldValue("ssnValue", val);
    transformDisplay(val);
    transformValue(val);
    event.target.setSelectionRange(val.length, val.length);
    setSsnValue(value);
  };

  const replaceAtCnf = (str, index, character) => { // NOSONAR
    return (
      str.substr(0, index) + character + str.substr(index + character.length)
    );
  };

  const transformDisplayCnf = (val) => { // NOSONAR
    let displayVal = val.replace(/[^0-9]/g, "").substr(0, 9);

    if (displayVal.length >= 4) {
      displayVal = displayVal.slice(0, 3) + "-" + displayVal.slice(3);
    }

    if (displayVal.length >= 7) {
      displayVal = displayVal.slice(0, 6) + "-" + displayVal.slice(6);
      const lastFour = displayVal.slice(7);
      displayVal = displayVal.slice(0, 7).replace(/\d/g, "*") + lastFour;
    } else {
      displayVal = displayVal.replace(/\d/g, "*");
    }

    return displayVal;
  };

  const transformValueCnf = (val) => {
    let cleanVal = val.replace(/[^0-9|\\*]/g, "");
    cleanVal = cleanVal.substr(0, 9);
    let updatedValue = valueCnf ? valueCnf : "";

    for (let i = 0, l = cleanVal.length; i < l; i++) {
      if (/[0-9]/g.exec(cleanVal[i])) {
        updatedValue = replaceAtCnf(updatedValue, i, cleanVal[i]);
      }
    }
    updatedValue = updatedValue.substr(0, cleanVal.length);
    formik.setFieldValue("ssnConfirmNumber", updatedValue);
    setValueCnf(updatedValue);
  };

  const syncInputCnf = (event) => {
    const val = event.target.value;
    formik.setFieldValue("ssnConfirmNumber", val);
    transformDisplayCnf(val);
    transformValueCnf(val);
    event.target.setSelectionRange(val.length, val.length);
    setSsnValueCnf(valueCnf);
  };

  return (
    <>
      <Form onSubmit={handleFormSubmit}>
        <div className="row">
          <div className="col-12 mt-0 mb-0">
            <span>Security Information</span>
          </div>
          <div className="col-md-12">
            <div className="col-md-6 p-0">
              <div className="main_form_box d-flex align-items-center mt-1">
                <svg
                  width="20"
                  height="16"
                  viewBox="0 0 20 16"
                  fill="#808080"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M18 0H2C0.89 0 0.00999999 0.89 0.00999999 2L0 14C0 15.11 0.89 16 2 16H18C19.11 16 20 15.11 20 14V2C20 0.89 19.11 0 18 0ZM18 14H2V8H18V14ZM18 4H2V2H18V4Z"
                    fill="#323232"
                  />
                </svg>

                <div className="form-group d-flex align-items-center">
                  <input
                    className="number input-field"
                    style={{ position: "absolute" }}
                    onChange={syncInput}
                    value={transformDisplay(value)}
                    maxLength={11}
                    placeholder="SSN/ ITIN"
                  />
                  <input
                    className="value input-field"
                    style={{
                      position: "absolute",
                      top: 0,
                      background: "transparent",
                      color: "transparent",
                      border: "none",
                      visibility: "hidden",
                    }}
                    value={ssnValue}
                    maxLength={9}
                    readOnly
                    disabled
                    type="hidden"
                  />
                </div>
              </div>
              <p className="SSN-input-message">
                *Please enter your SSN/ITIN carefully.
              </p>
            </div>
            {formik.touched.ssnNumber && formik.errors.ssnNumber ? (
              <div className="error sstn-error pt-2">
                {formik.errors.ssnNumber}
              </div>
            ) : null}
          </div>
          <div className="col-md-12">
            <div className="col-md-6 p-0">
              <div className="main_form_box d-flex align-items-center mt-4  ">
                <svg
                  width="20"
                  height="16"
                  viewBox="0 0 20 16"
                  fill="#808080"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M18 0H2C0.89 0 0.00999999 0.89 0.00999999 2L0 14C0 15.11 0.89 16 2 16H18C19.11 16 20 15.11 20 14V2C20 0.89 19.11 0 18 0ZM18 14H2V8H18V14ZM18 4H2V2H18V4Z"
                    fill="#323232"
                  />
                </svg>
                <div className="form-group d-flex align-items-center">
                  <input
                    className="number1 input-field"
                    style={{ position: "absolute" }}
                    onChange={syncInputCnf}
                    maxLength={11}
                    value={transformDisplayCnf(valueCnf)}
                    placeholder="Confirm SSN / ITIN"
                  />
                  <input
                    className="value1 input-field"
                    style={{
                      position: "absolute",
                      top: 0,
                      background: "transparent",
                      color: "transparent",
                      border: "none",
                      visibility: "hidden",
                    }}
                    value={ssnValueCnf}
                    maxLength={9}
                    readOnly
                    disabled
                    type="hidden"
                  />
                </div>
              </div>
              {formik.touched.ssnConfirmNumber &&
                formik.errors.ssnConfirmNumber ? (
                <div className="error">{formik.errors.ssnConfirmNumber}</div>
              ) : null}
            </div>
          </div>
          <div className="col-12 mt-2 mb-0">
            <span>Identity Verification</span>
          </div>
          <GrantorLicenseUploadField
            label="Driver's License Front"
            inputId="drivingLicenseFrontShow"
            fileRef={fileFrontRef}
            onTriggerClick={handleSvgFrontClick}
            onFileChange={drivingLicenseFront}
            onRemove={removeDrivingLicenseFront}
            fileName={formik.values.drivingLicenseFrontShow}
            previewUrl={frontPreview}
            isUploading={isUploadingFront}
            isUploaded={Boolean(formik.values.drivingLicenseFront)}
            error={formik.errors.drivingLicenseFront}
            showError={
              formik.submitCount > 0 || formik.touched.drivingLicenseFront
            }
          />
          <GrantorLicenseUploadField
            label="Driver's License Back"
            inputId="drivingLicenseBackShow"
            fileRef={fileBackRef}
            onTriggerClick={handleSvgBackClick}
            onFileChange={drivingLicenseBack}
            onRemove={removeDrivingLicenseBack}
            fileName={formik.values.drivingLicenseBackShow}
            previewUrl={backPreview}
            isUploading={isUploadingBack}
            isUploaded={Boolean(formik.values.drivingLicenseBack)}
            error={formik.errors.drivingLicenseBack}
            showError={
              formik.submitCount > 0 || formik.touched.drivingLicenseBack
            }
          />
        </div>

        <div className="mt-1 btn-div d-flex justify-content-between align-items-center">
          <div type="submit" className="SiteBtn2" onClick={handleGoBack}>
            Back
          </div>
          <Button type="submit" className="btn-thm SiteBtn" text="Continue" onClick={handleSubmit} />
        </div>
      </Form>
      <ModalCustom size="ml" handleClose="grantorModal" show={showPopup}>
        <ConfirmSpousePopup setSuccessorPopup={setShowPopup} />
      </ModalCustom>

    </>
  );
};

export default SpouseSignUp2;
